import Explainer from '../blocks';

import styles from './DelightCustomers.module.css';

const EXPLAINER_WIDTH = 662;
const EXPLAINER_HEIGHT = 460;

const DelightCustomers = () => {
  return (
    <Explainer
      width={EXPLAINER_WIDTH}
      height={EXPLAINER_HEIGHT}
      className={styles.root}
      once
    >
      <g transform="translate(9 105)">
        <g
          className={styles.delightCardOne}
          filter="url(#filter0_d_4053_23556)"
        >
          <g clipPath="url(#clip0_4053_23556)">
            <rect
              width="285"
              height="60"
              transform="translate(22 16)"
              fill="white"
            />
            <g clipPath="url(#clip1_4053_23556)">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M44.252 42.1668L46.7283 39.6904H48.5365L51.0128 42.1668V43.9749L48.5365 46.4513H46.7283L45.8973 45.6203L44.2168 47.3008L46.0055 49.0894L45.2984 49.7965L43.5097 48.0079L41.9883 49.5293V50.0803L43.5107 51.6027L42.8036 52.3098L40.9883 50.4945V49.1151L45.1902 44.9131L44.252 43.9749V42.1668ZM45.252 42.581V43.5607L47.1425 45.4513H48.1223L50.0128 43.5607V42.581L48.1223 40.6904L47.1425 40.6904L45.252 42.581Z"
                fill="#5F7886"
              />
            </g>
            <text
              fill="#2A6FE1"
              fontFamily="var(--font-family-mono)"
              fontSize="12"
              letterSpacing="0em"
            >
              <tspan x="64" y="50.2">
                a9f3d7e2b6c1g8h5i4j0k2m7n9p3q6{' '}
              </tspan>
            </text>
            <mask id="path-4-inside-1_4053_23556" fill="white">
              <path d="M307 16H435V76H307V16Z" />
            </mask>
            <path d="M307 16H435V76H307V16Z" fill="white" />
            <path
              d="M307 76H308V16H307H306V76H307Z"
              fill="#E1EAF3"
              mask="url(#path-4-inside-1_4053_23556)"
            />
            <text
              fill="#02121E"
              fontFamily="var(--font-family-mono)"
              fontSize="12"
              letterSpacing="0em"
            >
              <tspan x="323" y="50.2">
                tag:latest
              </tspan>
            </text>
            <mask id="path-7-inside-2_4053_23556" fill="white">
              <path d="M435 16H515.95V76H435V16Z" />
            </mask>
            <path d="M435 16H515.95V76H435V16Z" fill="white" />
            <path
              d="M435 76H436V16H435H434V76H435Z"
              fill="#E1EAF3"
              mask="url(#path-7-inside-2_4053_23556)"
            />
            <path
              d="M499.95 40.1271L492.375 46.1003L487.421 51.5591L482.841 47.8571L479.388 51.8728H474.92L471.468 46.1003L462.763 50.9861H453.189L451 50.5155"
              stroke="#2A6FE1"
              strokeWidth="1.5"
              fill="transparent"
            />
            <mask id="path-10-inside-3_4053_23556" fill="white">
              <path d="M515.949 16H622.949V76H515.949V16Z" />
            </mask>
            <path d="M515.949 16H622.949V76H515.949V16Z" fill="white" />
            <path
              d="M515.949 76H516.949V16H515.949H514.949V76H515.949Z"
              fill="#E1EAF3"
              mask="url(#path-10-inside-3_4053_23556)"
            />
            <rect
              x="531.949"
              y="34.5"
              width="75"
              height="23"
              rx="4"
              fill="#E2FCF0"
            />
            <text
              fill="#007C68"
              fontFamily="var(--font-family-mono)"
              fontSize="10"
              letterSpacing="0.04em"
            >
              <tspan x="540.383" y="49.5">
                READ ONLY
              </tspan>
            </text>
          </g>
        </g>
        <g
          className={styles.delightCardTwo}
          filter="url(#filter1_d_4053_23556)"
        >
          <g clipPath="url(#clip2_4053_23556)">
            <rect
              width="285"
              height="60"
              transform="translate(21 94.1074)"
              fill="white"
            />
            <g clipPath="url(#clip3_4053_23556)">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M43.252 120.274L45.7283 117.798H47.5365L50.0128 120.274V122.082L47.5365 124.559H45.7283L44.8973 123.728L43.2168 125.408L45.0055 127.197L44.2984 127.904L42.5097 126.115L40.9883 127.637V128.188L42.5107 129.71L41.8036 130.417L39.9883 128.602V127.222L44.1902 123.021L43.252 122.082V120.274ZM44.252 120.688V121.668L46.1425 123.559H47.1223L49.0128 121.668V120.688L47.1223 118.798L46.1425 118.798L44.252 120.688Z"
                fill="#5F7886"
              />
            </g>
            <text
              fill="#2A6FE1"
              fontFamily="var(--font-family-mono)"
              fontSize="12"
              letterSpacing="0em"
            >
              <tspan x="63" y="128.307">
                eyJhbGciOiJIUzI1NiIsInR5cCI6Ik
              </tspan>
            </text>
            <mask id="path-17-inside-4_4053_23556" fill="white">
              <path d="M306 94.1074H434V154.107H306V94.1074Z" />
            </mask>
            <path d="M306 94.1074H434V154.107H306V94.1074Z" fill="white" />
            <path
              d="M306 154.107H307V94.1074H306H305V154.107H306Z"
              fill="#E1EAF3"
              mask="url(#path-17-inside-4_4053_23556)"
            />
            <text
              fill="#02121E"
              fontFamily="var(--font-family-mono)"
              fontSize="12"
              letterSpacing="0em"
            >
              <tspan x="322" y="128.307">
                name:my-app
              </tspan>
            </text>
            <mask id="path-20-inside-5_4053_23556" fill="white">
              <path d="M434 94.1074H517V154.107H434V94.1074Z" />
            </mask>
            <path d="M434 94.1074H517V154.107H434V94.1074Z" fill="white" />
            <path
              d="M434 154.107H435V94.1074H434H433V154.107H434Z"
              fill="#E1EAF3"
              mask="url(#path-20-inside-5_4053_23556)"
            />
            <path
              d="M501 124.084L491.375 121.449L486.42 129.637L481.841 124.084L478.388 130.107H473.92L470.467 121.449L461.763 124.084L452.189 118.813L450 118.107"
              stroke="#2A6FE1"
              strokeWidth="1.5"
              fill="transparent"
            />
            <mask id="path-23-inside-6_4053_23556" fill="white">
              <path d="M517 94.1074H624V154.107H517V94.1074Z" />
            </mask>
            <path d="M517 94.1074H624V154.107H517V94.1074Z" fill="white" />
            <path
              d="M517 154.107H518V94.1074H517H516V154.107H517Z"
              fill="#E1EAF3"
              mask="url(#path-23-inside-6_4053_23556)"
            />
            <rect
              x="533"
              y="112.607"
              width="75"
              height="23"
              rx="4"
              fill="#E2FCF0"
            />
            <text
              fill="#007C68"
              fontFamily="var(--font-family-mono)"
              fontSize="10"
              letterSpacing="0.04em"
            >
              <tspan x="541.434" y="127.607">
                READ ONLY
              </tspan>
            </text>
          </g>
        </g>
        <g
          className={styles.delightCardThree}
          filter="url(#filter2_d_4053_23556)"
        >
          <g clipPath="url(#clip4_4053_23556)">
            <rect
              width="285"
              height="60"
              transform="translate(20 172.107)"
              fill="white"
            />
            <g clipPath="url(#clip5_4053_23556)">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M42.252 198.274L44.7283 195.798H46.5365L49.0128 198.274V200.082L46.5365 202.559H44.7283L43.8973 201.728L42.2168 203.408L44.0055 205.197L43.2984 205.904L41.5097 204.115L39.9883 205.637V206.188L41.5107 207.71L40.8036 208.417L38.9883 206.602V205.222L43.1902 201.021L42.252 200.082V198.274ZM43.252 198.688V199.668L45.1425 201.559H46.1223L48.0128 199.668V198.688L46.1223 196.798L45.1425 196.798L43.252 198.688Z"
                fill="#5F7886"
              />
            </g>
            <text
              fill="#2A6FE1"
              fontFamily="var(--font-family-mono)"
              fontSize="12"
              letterSpacing="0em"
            >
              <tspan x="62" y="206.307">
                SflKxwRJSMeKKF2QT4fwpMeJf36POk6
              </tspan>
            </text>
            <mask id="path-30-inside-7_4053_23556" fill="white">
              <path d="M305 172.107H433V232.107H305V172.107Z" />
            </mask>
            <path d="M305 172.107H433V232.107H305V172.107Z" fill="white" />
            <path
              d="M305 232.107H306V172.107H305H304V232.107H305Z"
              fill="#E1EAF3"
              mask="url(#path-30-inside-7_4053_23556)"
            />
            <text
              fill="#02121E"
              fontFamily="var(--font-family-mono)"
              fontSize="12"
              letterSpacing="0em"
            >
              <tspan x="321" y="206.307">
                format:docker
              </tspan>
            </text>
            <mask id="path-33-inside-8_4053_23556" fill="white">
              <path d="M433 172.107H516.812V232.107H433V172.107Z" />
            </mask>
            <path d="M433 172.107H516.812V232.107H433V172.107Z" fill="white" />
            <path
              d="M433 232.107H434V172.107H433H432V232.107H433Z"
              fill="#E1EAF3"
              mask="url(#path-33-inside-8_4053_23556)"
            />
            <path
              d="M500.812 202.141L491.033 205.938L486 194.141L481.347 202.141L477.84 193.463H473.301L469.793 205.938L460.95 202.141L451.224 209.735L449 210.752"
              stroke="#2A6FE1"
              strokeWidth="1.5"
              fill="transparent"
            />
            <mask id="path-36-inside-9_4053_23556" fill="white">
              <path d="M516.812 172.107H623.812V232.107H516.812V172.107Z" />
            </mask>
            <path
              d="M516.812 172.107H623.812V232.107H516.812V172.107Z"
              fill="white"
            />
            <path
              d="M516.812 232.107H517.812V172.107H516.812H515.812V232.107H516.812Z"
              fill="#E1EAF3"
              mask="url(#path-36-inside-9_4053_23556)"
            />
            <rect
              x="532.812"
              y="190.607"
              width="75"
              height="23"
              rx="4"
              fill="#E2FCF0"
            />
            <text
              fill="#007C68"
              fontFamily="var(--font-family-mono)"
              fontSize="10"
              letterSpacing="0.04em"
            >
              <tspan x="541.247" y="205.607">
                READ ONLY
              </tspan>
            </text>
          </g>
        </g>
        <defs>
          <filter
            id="filter0_d_4053_23556"
            x="2"
            y="0"
            width="640.949"
            height="100"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="4" />
            <feGaussianBlur stdDeviation="10" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0.486275 0 0 0 0 0.407843 0 0 0 0.15 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_4053_23556"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_4053_23556"
              result="shape"
            />
          </filter>
          <filter
            id="filter1_d_4053_23556"
            x="1"
            y="78.1074"
            width="643"
            height="100"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="4" />
            <feGaussianBlur stdDeviation="10" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0.486275 0 0 0 0 0.407843 0 0 0 0.15 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_4053_23556"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_4053_23556"
              result="shape"
            />
          </filter>
          <filter
            id="filter2_d_4053_23556"
            x="0"
            y="156.107"
            width="643.812"
            height="100"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="4" />
            <feGaussianBlur stdDeviation="10" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0.486275 0 0 0 0 0.407843 0 0 0 0.15 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_4053_23556"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_4053_23556"
              result="shape"
            />
          </filter>
          <clipPath id="clip0_4053_23556">
            <path
              d="M22 22C22 18.6863 24.6863 16 28 16H616.95C620.264 16 622.95 18.6863 622.95 22V70C622.95 73.3137 620.264 76 616.95 76H28C24.6863 76 22 73.3137 22 70V22Z"
              fill="white"
            />
          </clipPath>
          <clipPath id="clip1_4053_23556">
            <rect
              width="16"
              height="16"
              fill="white"
              transform="translate(38 38)"
            />
          </clipPath>
          <clipPath id="clip2_4053_23556">
            <path
              d="M21 100.107C21 96.7937 23.6863 94.1074 27 94.1074H618C621.314 94.1074 624 96.7937 624 100.107V148.107C624 151.421 621.314 154.107 618 154.107H27C23.6863 154.107 21 151.421 21 148.107V100.107Z"
              fill="white"
            />
          </clipPath>
          <clipPath id="clip3_4053_23556">
            <rect
              width="16"
              height="16"
              fill="white"
              transform="translate(37 116.107)"
            />
          </clipPath>
          <clipPath id="clip4_4053_23556">
            <path
              d="M20 178.107C20 174.794 22.6863 172.107 26 172.107H617.812C621.125 172.107 623.812 174.794 623.812 178.107V226.107C623.812 229.421 621.125 232.107 617.812 232.107H26C22.6863 232.107 20 229.421 20 226.107V178.107Z"
              fill="white"
            />
          </clipPath>
          <clipPath id="clip5_4053_23556">
            <rect
              width="16"
              height="16"
              fill="white"
              transform="translate(36 194.107)"
            />
          </clipPath>
        </defs>
      </g>
    </Explainer>
  );
};

export default DelightCustomers;
